// extracted by mini-css-extract-plugin
export var adminLayout = "survey-session-header-module--admin-layout--+Rxyq";
export var avatar = "survey-session-header-module--avatar--QweLW";
export var email = "survey-session-header-module--email--O6m6b";
export var innerWrapper = "survey-session-header-module--inner-wrapper--OVmeM";
export var name = "survey-session-header-module--name--3QTZd";
export var registerDate = "survey-session-header-module--register-date--JWNf+";
export var statusSelect = "survey-session-header-module--status-select--ALuWm";
export var surveySessionHeader = "survey-session-header-module--survey-session-header--m+7kT";